import { updateUserClubsList, updateUserRequestsList } from "../store/userSlice";
import {    doc,
            setDoc, 
            getDoc,
            onSnapshot,
            arrayUnion,
            arrayRemove,
            updateDoc} from "firebase/firestore";
import {    getAuth, 
            createUserWithEmailAndPassword,
            GoogleAuthProvider, 
            signInWithPopup,
            signInWithEmailAndPassword } from "firebase/auth";
import { createAvatar } from '@dicebear/core';
import { thumbs } from '@dicebear/collection';

import { db } from "./firestoreModel";
import { fillClubInfo } from "./firestoreUtils";

let userUnsubscribe = null; //save the onSnapshot unsubscribe function

export async function signInWithGoogleFirebase(){
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    console.log("signup with Google initiated");
    try{
        //Logga in med Google popup
        console.log("Creating user in auth");
        await signInWithPopup(auth, provider);
        const user = auth.currentUser;
        
        if (!user) {
            throw new Error("Google sign-in failed or was cancelled");
        }

       
        //Kontrollera om användaren finns i Firestore 
        const userDocRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(userDocRef);

        if(!docSnap.exists()){
            console.log("Created user in auth with uid: " + user.uid);
            await setDoc(userDocRef, {
                uid: user.uid,
                username: user.displayName,
                email: user.email,
                clubs: [],
                userIMG: createAvatar(thumbs, {seed: user.displayName}).toString(),
            });
        }
        return user;
    } catch(error){
        console.error("Google login failed", error);
        throw error;
    }
}

export async function createUser(email, password, FName, LName){
    const auth = getAuth();
    console.log("signUp entered");
    try {
        
        console.log("creating user in auth");
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        console.log("created user in auth with uid: " + userCredential.user.uid);
        await setDoc(doc(db, "users", userCredential.user.uid), {
            uid: userCredential.user.uid,
            username: FName + " " + LName,
            email: email,
            clubs: [],
            userIMG: createAvatar(thumbs, {seed: FName+LName}).toString(),
        });

        return userCredential;
    } catch (error) {
        throw error; 
    }
}


export async function logInUser(email, password) {
    const auth = getAuth();
    console.log("loggin entred with email: " +email+ ", and password: "+password);
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        return userCredential;
    } catch (error) {
        throw error; 
    }
}

/**
 * Starts listning on changes in the user and dispatches actions to update the list of users clubs and active requests 
 * on changes.
 */
export function userClubsAndRequestListListner(currentUserId, dispatch){ 
    // console.log("userClubListListner")
    // Guard against invalid/missing userId (e.g., during logout)
    if (!currentUserId || (typeof currentUserId === "string" && currentUserId.trim() === "")) {
        if (userUnsubscribe) {
            userUnsubscribe();
            userUnsubscribe = null;
        }
        return;
    }
    const userDoc = doc(db, "users", String(currentUserId))

    if(userUnsubscribe)
        userUnsubscribe();

    userUnsubscribe = onSnapshot(userDoc, async (snapshot) =>{
        console.log("vi har sett en ändring i userstate")
        const data = snapshot.data();
        const pendingClubs = await fillClubInfo(data.pendingRequests)
        const userClubs = data?.clubs
        
        dispatch(updateUserClubsList({userClubs: Array.isArray(userClubs) ? userClubs : []}))
        dispatch(updateUserRequestsList({pendingRequests: Array.isArray(pendingClubs) ? pendingClubs : []}))
        }, (error) => {
            console.error("could not update list of active clubs", error)
        }
    );
}   

/**
 * Get all information in firestore for a user
 */
export async function getUserInfo(userId) {
    // console.log("Fetching user:", userId);
    if (!userId || (typeof userId === "string" && userId.trim() === "")) {
        console.error("getUserInfo: Invalid userId", { userId });
        return null;
    }
    const userDoc = doc(db, "users", String(userId));
  
  return getDoc(userDoc, { source: "server" })  
    .then(userSnap => {
      const data = userSnap.data();
      return data;
    })
    .catch(error => {
      console.error("Error fetching user:", error);
      return null;
    });
}

/**
 * Save the list of users active clubs to firestore, not in use
 */
export function saveUserClubsList(currentUserId, userClubs){ 
    // console.log(currentUserId)
    // console.log(userClubs)
    if(!userClubs){
        return
    }
    if (!currentUserId || (typeof currentUserId === "string" && currentUserId.trim() === "")) {
        console.error("saveUserClubsList: Invalid currentUserId", { currentUserId });
        return;
    }
    const userDoc = doc(db, "users", currentUserId)
    try{
        setDoc(userDoc,{
            clubs: userClubs
        }, {merge: true})
    }
    catch{
        console.error("Failed to save userclubs", error)
    }
}
/**
 * Add a club to users list of active clubs in firestore
 */
export async function addToUsersClubList(userId, clubId){
    if (!userId || (typeof userId === "string" && userId.trim() === "")) {
        console.error("addToUsersClubList: Invalid userId", { userId, clubId });
        return;
    }
    const userDoc = doc(db, "users", userId)
    await updateDoc(userDoc, {
        clubs: arrayUnion(String(clubId))
    })
}
/**
 * Add a club to users list of pending requests in firestore
 */
export async function addClubToUsersRequests(clubId, userId){
    if (!userId || (typeof userId === "string" && userId.trim() === "")) {
        console.error("addClubToUsersRequests: Invalid userId", { userId, clubId });
        return;
    }
    const userDoc = doc(db, "users", userId)
    await updateDoc(userDoc, {
        pendingRequests: arrayUnion(String(clubId))
    })
    console.log("kört add club to user requestlist")
}
/**
 * remove a club from users list of pending requests in firestore
 */
export async function removeClubFromUsersRequests(clubId, userId){
    if (!userId || (typeof userId === "string" && userId.trim() === "")) {
        console.error("removeClubFromUsersRequests: Invalid userId", { userId, clubId });
        return;
    }
    const userDoc = doc(db, "users", userId)
    if (clubId == null) {
        console.error("removeClubFromUsersRequests: clubId is undefined/null", { userId, clubId });
        return;
    }
    await updateDoc(userDoc, {
        pendingRequests: arrayRemove(String(clubId))
    })
    console.log("kört remove club frpm user requestlist")
}








